export const SHOW_LOGO = false;
export const SHOW_FOOTER = true;
